import React from 'react';
import cx from 'classnames';

import styles from '../../components/Layout/Layout.module.scss';

export type LayoutMainProps = {
  className?: string;
};

export const LayoutMain: React.FC<LayoutMainProps> = ({ children, className }) => (
  <main className={cx(styles.layout__main, className)}>{children}</main>
);
